document.addEventListener('DOMContentLoaded', () => {
  // obecne
  let bodyWidth = window.innerWidth;

  // události při resize okna
  window.addEventListener('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
      // zrestuj vyhledávání v hlavičce
      resetSearch();
      // zrestuj aside box
      resetAside();
    }
  });
  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if (document.querySelector('.nav-switcher').classList.contains('is-open')) {
      document.querySelector('.nav-switcher').classList.remove('is-open');
      document.querySelector('.nav').classList.remove('is-open');
      document.querySelector('.header').classList.remove('is-nav-open');
      document.body.classList.remove('is-unscrollable');
    } else {
      document.querySelector('.nav-switcher').classList.add('is-open');
      document.querySelector('.nav').classList.add('is-open');
      document.querySelector('.header').classList.add('is-nav-open');
      document.body.classList.add('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    document.querySelector('.nav-switcher').classList.remove('is-open');
    document.querySelector('.nav').classList.remove('is-open');
    document.querySelector('.header').classList.remove('is-nav-open');
    document.body.classList.remove('is-unscrollable');
  }

  // při změně rozlišení resetujeme aside
  function resetAside() {
    if (document.querySelector('.aside')) {
      document.querySelector('.aside').classList.remove('is-open');
    }
  }
  // spouštěč
  document
    .querySelector('.nav-switcher')
    .addEventListener('click', function () {
      switchMenu();
    });

  // při změně rozlišení resetujeme vyhledávání v hlavičce
  function resetSearch() {
    if (document.querySelector('.nav__search')) {
      document.querySelector('.nav__search').classList.add('is-shrinked');
    }
  }

  // události při načtení stránky
  window.addEventListener('load', function () {
    // AOS fix pro první načítání
    // AOS.refresh();
  });

  // události při scroolování
  window.addEventListener('scroll', function () {
    //...
  });

  // modal okna
  if (document.querySelector('.modal')) {
    modal();
  }

  // alerty
  if (document.querySelector('.alert')) {
    alert();
  }

  // hlavička vyhledávání
  if (document.querySelector('.nav__search')) {
    document
      .querySelector('.nav__search-icon')
      .addEventListener('click', function (event) {
        event.stopPropagation();
        this.closest('.nav__search').classList.remove('is-shrinked');
      });
  }

  // slider
  if (document.querySelector('.slider')) {
    const slider = new Glider(document.querySelector('.slider'), {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      dots: '.slider__dots',
      scrollLock: true,
      scrollLockDelay: 0,
      rewind: true,
    });
    gliderAutoplay(slider, { interval: 6000 });
  }

  // načíst další
  if (document.querySelector('.important__show-more-btn')) {
    document
      .querySelector('.important__show-more-btn')
      .addEventListener('click', function () {
        this.classList.add('is-hidden');
        importantShowMore = document.getElementsByClassName(
          'important__show-more'
        );
        for (i = 0; i < importantShowMore.length; i++) {
          importantShowMore[i].classList.add('is-open');
        }
      });
  }

  // blog article list - show more button
  const showMoreArticleLink = document.getElementById(
    'show-more-articles-button'
  );
  const blogArticles = document.getElementsByClassName('blog-news-article');
  if (showMoreArticleLink) {
    showMoreArticleLink.addEventListener('click', function () {
      blogArticles.forEach(function (blogArticle) {
        blogArticle.classList.remove('is-hidden');
      });
      showMoreArticleLink.classList.add('is-hidden');
      showMoreArticleLink.classList.remove('news__show-more');
    });
  }

  // faq
  if (document.querySelector('.faq')) {
    faqQuestion = document.getElementsByClassName('faq__question');
    for (i = 0; i < faqQuestion.length; i++) {
      faqQuestion[i].addEventListener('click', function () {
        if (this.closest('.faq__item').classList.contains('is-open')) {
          this.closest('.faq__item').classList.remove('is-open');
        } else {
          this.closest('.faq__item').classList.add('is-open');
        }
      });
    }
  }

  // nav dropdown
  if (document.querySelector('.js-nav-dropdown')) {
    navDropdownInside = document.getElementsByClassName('js-nav-dropdown');
    for (i = 0; i < navDropdownInside.length; i++) {
      navDropdownInside[i].addEventListener('click', function () {
        if (this.classList.contains('is-active')) {
          this.classList.remove('is-active');
        } else {
          this.classList.add('is-active');
        }
      });
    }
  }

  // aside box content (mobilní zobrazení)
  if (document.querySelector('.aside__box-title')) {
    document
      .querySelector('.aside__box-title')
      .addEventListener('click', function (event) {
        event.stopPropagation();
        this.closest('.aside').classList.toggle('is-open');
      });
  }

  // footer menu dropwdown
  if (document.querySelector('.js-menu-dropdown')) {
    document
      .querySelectorAll('.js-menu-dropdown').forEach(function(element) {
        element.addEventListener('click', function (event) {
            event.stopPropagation();
            this.classList.toggle('is-open');
        });
      });
  }

  // services-item jako select (dropdown)
  if (document.querySelector('.services-item--select')) {
    servicesSelect = document.getElementsByClassName('services-item--select');

    for (i = 0; i < servicesSelect.length; i++) {
      servicesSelect[i].addEventListener('click', function (event) {
        event.stopPropagation();
        if (this.classList.contains('is-open')) {
          this.classList.remove('is-open');
        } else {
          servicesSelect.forEach(function (element) {
            if (element.classList.contains('is-open')) {
              element.classList.remove('is-open');
            }
          });
          this.classList.add('is-open');
        }
      });
    }

    document.addEventListener('click', function () {
      servicesSelect.forEach(function (element) {
        if (element.classList.contains('is-open')) {
          element.classList.remove('is-open');
        }
      });
    });
  }

  // simplebar scrollbar pro services-item__select-box
  if ($('.services-item__select-box').length) {
    const servicesItemSelectBox = document.getElementsByClassName(
      'services-item__select-box'
    );
    for (let i = 0; i < servicesItemSelectBox.length; i++) {
      new SimpleBar(servicesItemSelectBox[i], {
        autoHide: false,
      });
    }
  }

  // Select2 vyhledávání účastníků v modalním okně
  if (document.querySelector('.js-modal-search')) {
    executorEvents();
  }

  if (document.querySelector('#modal-register')) {
    executorEventsSummary();
  }

  if (document.querySelector('#modal-pay')) {
    executorEventsPayment();
  }

  if (document.querySelector('#modal-register-concipient')) {
    concipientEventRegistration();
  }

  if (document.querySelector('#modal-pay-concipient')) {
    concipientEventsPayment();
  }

  if (
    document.querySelector('#cancel-registration-button') &&
    document.getElementById('event-participant-number')
  ) {
    concipientCancelRegistration();
  }

  if (document.querySelector('.ldap-category-select')) {
    userLdapForm();
  }

  // Shrnutí platby (mobilní zobrazení)
  if (document.querySelector('.modal__summary-open')) {
    summaryBlock = document.getElementsByClassName('modal__summary-open');
    for (i = 0; i < summaryBlock.length; i++) {
      summaryBlock[i].addEventListener('click', function (event) {
        event.stopPropagation();
        this.closest('.modal__summary').classList.toggle('is-open');
      });
    }
  }

  if (document.querySelector('.journal-overview')) {
    journalPage();
  }
  if (document.querySelector('.event-list')) {
    eventList();
  }

  // email user create validation
  if (
    document.querySelector('.emailValidate') &&
    document.getElementById('isCreateAction')
  ) {
    userCreateValidation();
    employeeNumberValidate();
  }

  if (
    document.querySelector('.employeeNumberValidate') &&
    document.getElementById('isEditAction')
  ) {
    employeeNumberValidate();
  }

  if (document.querySelector('.deleteValidate')) {
    deleteExecutorValidate();
  }

  if (document.querySelector('.services')) {
    showMoreServices();
  }

  if (document.getElementById('executorEventRegistrationParticipants')) {
    executorCancelRegistration();
    executorEditParticipants();
  }

  if (document.querySelector('.news--overview-form')) {
    newsOverview();
  }

  // galerie
  if (document.querySelector('.js-gallery')) {
    // new SimpleLightbox('.js-gallery a', {
    //   showCounter: false,
    //  });
    const galleries = document.querySelectorAll('.js-gallery');

    galleries.forEach((gallery) => {
      new SimpleLightbox(gallery.querySelectorAll('a'), {
        showCounter: false,
      });
    });
  }

  if (document.getElementById('advisory')) {
    advisory();
  }
});
